/** ============================================================================
======== This file was automatically generated. Do not edit manually. =========
================================================================================ */

import * as Operations from "@magento-api-v2/__generated__/magento-api-queries.documents";
import type * as OperationTypes from "@magento-api-v2/__generated__/operation-types";
import { type GraphQLClient, type RequestOptions } from "graphql-request";

type GraphQLClientRequestHeaders = RequestOptions["requestHeaders"];

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
  variables?: any
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    addBundleProductsToCart(
      variables: OperationTypes.MagentoApiAddBundleProductsToCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiAddBundleProductsToCartMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiAddBundleProductsToCartMutationResponse>({
            document: Operations.AddBundleProductsToCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "addBundleProductsToCart",
        "mutation",
        variables
      );
    },
    addConfigurableProductsToCart(
      variables: OperationTypes.MagentoApiAddConfigurableProductsToCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiAddConfigurableProductsToCartMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiAddConfigurableProductsToCartMutationResponse>({
            document: Operations.AddConfigurableProductsToCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "addConfigurableProductsToCart",
        "mutation",
        variables
      );
    },
    addProductsToCart(
      variables: OperationTypes.MagentoApiAddProductsToCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiAddProductsToCartMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiAddProductsToCartMutationResponse>({
            document: Operations.AddProductsToCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "addProductsToCart",
        "mutation",
        variables
      );
    },
    addSimpleProductsToCart(
      variables: OperationTypes.MagentoApiAddSimpleProductsToCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiAddSimpleProductsToCartMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiAddSimpleProductsToCartMutationResponse>({
            document: Operations.AddSimpleProductsToCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "addSimpleProductsToCart",
        "mutation",
        variables
      );
    },
    applyCampaignToCart(
      variables: OperationTypes.MagentoApiApplyCampaignToCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiApplyCampaignToCartMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiApplyCampaignToCartMutationResponse>({
            document: Operations.ApplyCampaignToCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "applyCampaignToCart",
        "mutation",
        variables
      );
    },
    applyCouponsToCart(
      variables: OperationTypes.MagentoApiApplyCouponsToCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiApplyCouponsToCartMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiApplyCouponsToCartMutationResponse>({
            document: Operations.ApplyCouponsToCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "applyCouponsToCart",
        "mutation",
        variables
      );
    },
    cancelOrder(
      variables: OperationTypes.MagentoApiCancelOrderMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiCancelOrderMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiCancelOrderMutationResponse>({
            document: Operations.CancelOrderDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "cancelOrder",
        "mutation",
        variables
      );
    },
    createEmptyCart(
      variables?: OperationTypes.MagentoApiCreateEmptyCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiCreateEmptyCartMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiCreateEmptyCartMutationResponse>({
            document: Operations.CreateEmptyCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "createEmptyCart",
        "mutation",
        variables
      );
    },
    getOrderStatuses(
      variables?: OperationTypes.MagentoApiGetOrderStatusesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetOrderStatusesQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetOrderStatusesQueryResponse>({
            document: Operations.GetOrderStatusesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOrderStatuses",
        "query",
        variables
      );
    },
    mergeCarts(
      variables: OperationTypes.MagentoApiMergeCartsMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiMergeCartsMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiMergeCartsMutationResponse>({
            document: Operations.MergeCartsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "mergeCarts",
        "mutation",
        variables
      );
    },
    placeOrder(
      variables: OperationTypes.MagentoApiPlaceOrderMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiPlaceOrderMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiPlaceOrderMutationResponse>({
            document: Operations.PlaceOrderDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "placeOrder",
        "mutation",
        variables
      );
    },
    removeCampaignFromCart(
      variables: OperationTypes.MagentoApiRemoveCampaignFromCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiRemoveCampaignFromCartMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiRemoveCampaignFromCartMutationResponse>({
            document: Operations.RemoveCampaignFromCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "removeCampaignFromCart",
        "mutation",
        variables
      );
    },
    removeCouponsFromCart(
      variables: OperationTypes.MagentoApiRemoveCouponsFromCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiRemoveCouponsFromCartMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiRemoveCouponsFromCartMutationResponse>({
            document: Operations.RemoveCouponsFromCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "removeCouponsFromCart",
        "mutation",
        variables
      );
    },
    removeItemFromCart(
      variables: OperationTypes.MagentoApiRemoveItemFromCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiRemoveItemFromCartMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiRemoveItemFromCartMutationResponse>({
            document: Operations.RemoveItemFromCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "removeItemFromCart",
        "mutation",
        variables
      );
    },
    setAdditionalAttributes(
      variables: OperationTypes.MagentoApiSetAdditionalAttributesMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiSetAdditionalAttributesMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiSetAdditionalAttributesMutationResponse>({
            document: Operations.SetAdditionalAttributesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setAdditionalAttributes",
        "mutation",
        variables
      );
    },
    setAddressesOnCart(
      variables: OperationTypes.MagentoApiSetAddressesOnCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiSetAddressesOnCartMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiSetAddressesOnCartMutationResponse>({
            document: Operations.SetAddressesOnCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setAddressesOnCart",
        "mutation",
        variables
      );
    },
    setBillingAddressOnCart(
      variables: OperationTypes.MagentoApiSetBillingAddressOnCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiSetBillingAddressOnCartMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiSetBillingAddressOnCartMutationResponse>({
            document: Operations.SetBillingAddressOnCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setBillingAddressOnCart",
        "mutation",
        variables
      );
    },
    setBillingAddressOnCartByAddressId(
      variables: OperationTypes.MagentoApiSetBillingAddressOnCartByAddressIdMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiSetBillingAddressOnCartByAddressIdMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiSetBillingAddressOnCartByAddressIdMutationResponse>({
            document: Operations.SetBillingAddressOnCartByAddressIdDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setBillingAddressOnCartByAddressId",
        "mutation",
        variables
      );
    },
    setCheckoutFastFlowCart(
      variables: OperationTypes.MagentoApiSetCheckoutFastFlowCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiSetCheckoutFastFlowCartMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiSetCheckoutFastFlowCartMutationResponse>({
            document: Operations.SetCheckoutFastFlowCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setCheckoutFastFlowCart",
        "mutation",
        variables
      );
    },
    setPaymentMethodOnCart(
      variables: OperationTypes.MagentoApiSetPaymentMethodOnCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiSetPaymentMethodOnCartMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiSetPaymentMethodOnCartMutationResponse>({
            document: Operations.SetPaymentMethodOnCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setPaymentMethodOnCart",
        "mutation",
        variables
      );
    },
    setShippingAddressesOnCart(
      variables: OperationTypes.MagentoApiSetShippingAddressesOnCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiSetShippingAddressesOnCartMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiSetShippingAddressesOnCartMutationResponse>({
            document: Operations.SetShippingAddressesOnCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setShippingAddressesOnCart",
        "mutation",
        variables
      );
    },
    setShippingAddressesOnCartByAddressId(
      variables: OperationTypes.MagentoApiSetShippingAddressesOnCartByAddressIdMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiSetShippingAddressesOnCartByAddressIdMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiSetShippingAddressesOnCartByAddressIdMutationResponse>({
            document: Operations.SetShippingAddressesOnCartByAddressIdDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setShippingAddressesOnCartByAddressId",
        "mutation",
        variables
      );
    },
    setShippingAddressesOnCartWithMethods(
      variables: OperationTypes.MagentoApiSetShippingAddressesOnCartWithMethodsMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiSetShippingAddressesOnCartWithMethodsMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiSetShippingAddressesOnCartWithMethodsMutationResponse>({
            document: Operations.SetShippingAddressesOnCartWithMethodsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setShippingAddressesOnCartWithMethods",
        "mutation",
        variables
      );
    },
    setShippingMethodsOnCart(
      variables: OperationTypes.MagentoApiSetShippingMethodsOnCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiSetShippingMethodsOnCartMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiSetShippingMethodsOnCartMutationResponse>({
            document: Operations.SetShippingMethodsOnCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setShippingMethodsOnCart",
        "mutation",
        variables
      );
    },
    updateCartItemQuantity(
      variables: OperationTypes.MagentoApiUpdateCartItemQuantityMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiUpdateCartItemQuantityMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiUpdateCartItemQuantityMutationResponse>({
            document: Operations.UpdateCartItemQuantityDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "updateCartItemQuantity",
        "mutation",
        variables
      );
    },
    updateCustomerAddress(
      variables: OperationTypes.MagentoApiUpdateCustomerAddressMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiUpdateCustomerAddressMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiUpdateCustomerAddressMutationResponse>({
            document: Operations.UpdateCustomerAddressDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "updateCustomerAddress",
        "mutation",
        variables
      );
    },
    updatePaymentMethod(
      variables: OperationTypes.MagentoApiUpdatePaymentMethodMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiUpdatePaymentMethodMutationResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiUpdatePaymentMethodMutationResponse>({
            document: Operations.UpdatePaymentMethodDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "updatePaymentMethod",
        "mutation",
        variables
      );
    },
    getAvailablePaymentMethods(
      variables: OperationTypes.MagentoApiGetAvailablePaymentMethodsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetAvailablePaymentMethodsQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetAvailablePaymentMethodsQueryResponse>({
            document: Operations.GetAvailablePaymentMethodsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getAvailablePaymentMethods",
        "query",
        variables
      );
    },
    GetBrandConsumablesMatrix(
      variables: OperationTypes.MagentoApiGetBrandConsumablesMatrixQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetBrandConsumablesMatrixQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetBrandConsumablesMatrixQueryResponse>({
            document: Operations.GetBrandConsumablesMatrixDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetBrandConsumablesMatrix",
        "query",
        variables
      );
    },
    GetBrandConsumables(
      variables: OperationTypes.MagentoApiGetBrandConsumablesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetBrandConsumablesQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetBrandConsumablesQueryResponse>({
            document: Operations.GetBrandConsumablesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetBrandConsumables",
        "query",
        variables
      );
    },
    getCartId(
      variables: OperationTypes.MagentoApiGetCartIdQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCartIdQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCartIdQueryResponse>({
            document: Operations.GetCartIdDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCartId",
        "query",
        variables
      );
    },
    getCartItems(
      variables: OperationTypes.MagentoApiGetCartItemsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCartItemsQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCartItemsQueryResponse>({
            document: Operations.GetCartItemsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCartItems",
        "query",
        variables
      );
    },
    getCartPrices(
      variables: OperationTypes.MagentoApiGetCartPricesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCartPricesQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCartPricesQueryResponse>({
            document: Operations.GetCartPricesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCartPrices",
        "query",
        variables
      );
    },
    getCartSelectedPaymentMethod(
      variables: OperationTypes.MagentoApiGetCartSelectedPaymentMethodQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCartSelectedPaymentMethodQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCartSelectedPaymentMethodQueryResponse>({
            document: Operations.GetCartSelectedPaymentMethodDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCartSelectedPaymentMethod",
        "query",
        variables
      );
    },
    getConsumablesMatrix(
      variables?: OperationTypes.MagentoApiGetConsumablesMatrixQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetConsumablesMatrixQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetConsumablesMatrixQueryResponse>({
            document: Operations.GetConsumablesMatrixDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getConsumablesMatrix",
        "query",
        variables
      );
    },
    getCountiesForProfile(
      variables?: OperationTypes.MagentoApiGetCountiesForProfileQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCountiesForProfileQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCountiesForProfileQueryResponse>({
            document: Operations.GetCountiesForProfileDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCountiesForProfile",
        "query",
        variables
      );
    },
    getCountries(
      variables?: OperationTypes.MagentoApiGetCountriesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCountriesQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCountriesQueryResponse>({
            document: Operations.GetCountriesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCountries",
        "query",
        variables
      );
    },
    getCountry(
      variables: OperationTypes.MagentoApiGetCountryQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCountryQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCountryQueryResponse>({
            document: Operations.GetCountryDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCountry",
        "query",
        variables
      );
    },
    getCurrency(
      variables?: OperationTypes.MagentoApiGetCurrencyQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCurrencyQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCurrencyQueryResponse>({
            document: Operations.GetCurrencyDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCurrency",
        "query",
        variables
      );
    },
    getCustomerAddresses(
      variables?: OperationTypes.MagentoApiGetCustomerAddressesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCustomerAddressesQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCustomerAddressesQueryResponse>({
            document: Operations.GetCustomerAddressesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerAddresses",
        "query",
        variables
      );
    },
    getCustomerCart(
      variables?: OperationTypes.MagentoApiGetCustomerCartQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCustomerCartQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCustomerCartQueryResponse>({
            document: Operations.GetCustomerCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerCart",
        "query",
        variables
      );
    },
    getCustomerCartId(
      variables?: OperationTypes.MagentoApiGetCustomerCartIdQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCustomerCartIdQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCustomerCartIdQueryResponse>({
            document: Operations.GetCustomerCartIdDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerCartId",
        "query",
        variables
      );
    },
    getCustomerCartOrderPrices(
      variables: OperationTypes.MagentoApiGetCustomerCartOrderPricesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCustomerCartOrderPricesQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCustomerCartOrderPricesQueryResponse>({
            document: Operations.GetCustomerCartOrderPricesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerCartOrderPrices",
        "query",
        variables
      );
    },
    getCustomerCartPrices(
      variables: OperationTypes.MagentoApiGetCustomerCartPricesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCustomerCartPricesQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCustomerCartPricesQueryResponse>({
            document: Operations.GetCustomerCartPricesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerCartPrices",
        "query",
        variables
      );
    },
    getCustomerCoupons(
      variables: OperationTypes.MagentoApiGetCustomerCouponsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCustomerCouponsQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCustomerCouponsQueryResponse>({
            document: Operations.GetCustomerCouponsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerCoupons",
        "query",
        variables
      );
    },
    getCustomerExportedOrderDetails(
      variables: OperationTypes.MagentoApiGetCustomerExportedOrderDetailsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCustomerExportedOrderDetailsQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCustomerExportedOrderDetailsQueryResponse>({
            document: Operations.GetCustomerExportedOrderDetailsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerExportedOrderDetails",
        "query",
        variables
      );
    },
    getCustomerOrder(
      variables: OperationTypes.MagentoApiGetCustomerOrderQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCustomerOrderQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCustomerOrderQueryResponse>({
            document: Operations.GetCustomerOrderDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerOrder",
        "query",
        variables
      );
    },
    getCustomerOrderDetails(
      variables: OperationTypes.MagentoApiGetCustomerOrderDetailsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCustomerOrderDetailsQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCustomerOrderDetailsQueryResponse>({
            document: Operations.GetCustomerOrderDetailsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerOrderDetails",
        "query",
        variables
      );
    },
    getCustomerOrders(
      variables?: OperationTypes.MagentoApiGetCustomerOrdersQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCustomerOrdersQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCustomerOrdersQueryResponse>({
            document: Operations.GetCustomerOrdersDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerOrders",
        "query",
        variables
      );
    },
    getCustomerOrdersAllStores(
      variables?: OperationTypes.MagentoApiGetCustomerOrdersAllStoresQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCustomerOrdersAllStoresQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCustomerOrdersAllStoresQueryResponse>({
            document: Operations.GetCustomerOrdersAllStoresDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerOrdersAllStores",
        "query",
        variables
      );
    },
    getCustomerOrdersCount(
      variables?: OperationTypes.MagentoApiGetCustomerOrdersCountQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCustomerOrdersCountQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCustomerOrdersCountQueryResponse>({
            document: Operations.GetCustomerOrdersCountDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerOrdersCount",
        "query",
        variables
      );
    },
    getCustomerOrdersPagination(
      variables?: OperationTypes.MagentoApiGetCustomerOrdersPaginationQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCustomerOrdersPaginationQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCustomerOrdersPaginationQueryResponse>({
            document: Operations.GetCustomerOrdersPaginationDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerOrdersPagination",
        "query",
        variables
      );
    },
    getCustomerOrdersStatuses(
      variables?: OperationTypes.MagentoApiGetCustomerOrdersStatusesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetCustomerOrdersStatusesQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetCustomerOrdersStatusesQueryResponse>({
            document: Operations.GetCustomerOrdersStatusesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerOrdersStatuses",
        "query",
        variables
      );
    },
    getLastCustomerOrder(
      variables?: OperationTypes.MagentoApiGetLastCustomerOrderQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetLastCustomerOrderQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetLastCustomerOrderQueryResponse>({
            document: Operations.GetLastCustomerOrderDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getLastCustomerOrder",
        "query",
        variables
      );
    },
    getOrderAttributes(
      variables?: OperationTypes.MagentoApiGetOrderAttributesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetOrderAttributesQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetOrderAttributesQueryResponse>({
            document: Operations.GetOrderAttributesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOrderAttributes",
        "query",
        variables
      );
    },
    getOrderDeliveryLimits(
      variables?: OperationTypes.MagentoApiGetOrderDeliveryLimitsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetOrderDeliveryLimitsQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetOrderDeliveryLimitsQueryResponse>({
            document: Operations.GetOrderDeliveryLimitsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOrderDeliveryLimits",
        "query",
        variables
      );
    },
    getProductImage(
      variables: OperationTypes.MagentoApiGetProductImageQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetProductImageQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetProductImageQueryResponse>({
            document: Operations.GetProductImageDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getProductImage",
        "query",
        variables
      );
    },
    getProductImageDescription(
      variables: OperationTypes.MagentoApiGetProductImageDescriptionQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetProductImageDescriptionQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetProductImageDescriptionQueryResponse>({
            document: Operations.GetProductImageDescriptionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getProductImageDescription",
        "query",
        variables
      );
    },
    getProductPrice(
      variables: OperationTypes.MagentoApiGetProductPriceQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetProductPriceQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetProductPriceQueryResponse>({
            document: Operations.GetProductPriceDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getProductPrice",
        "query",
        variables
      );
    },
    getProducts(
      variables?: OperationTypes.MagentoApiGetProductsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetProductsQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetProductsQueryResponse>({
            document: Operations.GetProductsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getProducts",
        "query",
        variables
      );
    },
    getProductsEssentials(
      variables?: OperationTypes.MagentoApiGetProductsEssentialsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetProductsEssentialsQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetProductsEssentialsQueryResponse>({
            document: Operations.GetProductsEssentialsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getProductsEssentials",
        "query",
        variables
      );
    },
    getPromoGiftInfo(
      variables: OperationTypes.MagentoApiGetPromoGiftInfoQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetPromoGiftInfoQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetPromoGiftInfoQueryResponse>({
            document: Operations.GetPromoGiftInfoDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getPromoGiftInfo",
        "query",
        variables
      );
    },
    getPromotionalOffers(
      variables?: OperationTypes.MagentoApiGetPromotionalOffersQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetPromotionalOffersQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetPromotionalOffersQueryResponse>({
            document: Operations.GetPromotionalOffersDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getPromotionalOffers",
        "query",
        variables
      );
    },
    getShippingMethods(
      variables: OperationTypes.MagentoApiGetShippingMethodsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetShippingMethodsQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetShippingMethodsQueryResponse>({
            document: Operations.GetShippingMethodsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getShippingMethods",
        "query",
        variables
      );
    },
    getSticksMatrix(
      variables?: OperationTypes.MagentoApiGetSticksMatrixQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetSticksMatrixQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetSticksMatrixQueryResponse>({
            document: Operations.GetSticksMatrixDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getSticksMatrix",
        "query",
        variables
      );
    },
    getStockStatuses(
      variables?: OperationTypes.MagentoApiGetStockStatusesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetStockStatusesQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetStockStatusesQueryResponse>({
            document: Operations.GetStockStatusesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getStockStatuses",
        "query",
        variables
      );
    },
    getStoreConfig(
      variables?: OperationTypes.MagentoApiGetStoreConfigQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetStoreConfigQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetStoreConfigQueryResponse>({
            document: Operations.GetStoreConfigDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getStoreConfig",
        "query",
        variables
      );
    },
    getUrlKeys(
      variables: OperationTypes.MagentoApiGetUrlKeysQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetUrlKeysQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetUrlKeysQueryResponse>({
            document: Operations.GetUrlKeysDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getUrlKeys",
        "query",
        variables
      );
    },
    getXSellingPopup(
      variables: OperationTypes.MagentoApiGetXSellingPopupQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<OperationTypes.MagentoApiGetXSellingPopupQueryResponse> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OperationTypes.MagentoApiGetXSellingPopupQueryResponse>({
            document: Operations.GetXSellingPopupDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getXSellingPopup",
        "query",
        variables
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
